import {createVariableProperty} from '../core';
import type {StylePlugin} from '../core';

export const size: StylePlugin = {
  properties: {
    'padding-top': createVariableProperty('padding-top'),
    'padding-bottom': createVariableProperty('padding-bottom'),
  },
};
